package cz.vojtechhoranek.site.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import cz.vojtechhoranek.site.PrimaryColorPalette
import cz.vojtechhoranek.site.TertiaryColorPalette
import cz.vojtechhoranek.site.toSitePalette
import cz.vojtechhoranek.site.localization.LocalSiteText
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Text

@Composable
fun ContactButtons() {
    val sitePalette = ColorMode.current.toSitePalette()

    Row(
        modifier = Modifier
            .gap(1.cssRem)
            .flexWrap(FlexWrap.Wrap)
    ) {
        val ctx = rememberPageContext()
        Button(
            onClick = {
                ctx.router.navigateTo(
                    "mailto:vojtechhoranek@gmail.com",
                    openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                )
            },
            colorPalette = PrimaryColorPalette
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(0.5.cssRem),
                modifier = Modifier
                    .color(sitePalette.onPrimary),
            ) {
                SiteIcon(SiteIconKind.Mail)
                Text(LocalSiteText.current.contact)
            }
        }

        Button(
            onClick = {
                ctx.router.navigateTo(
                    "https://github.com/vojta-horanek",
                )
            },
            colorPalette = TertiaryColorPalette
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(0.5.cssRem),
                modifier = Modifier
                    .color(sitePalette.onTertiary),
            ) {
                SiteIcon(SiteIconKind.GitHub)
                Text("GitHub")
            }
        }

        Button(
            onClick = {
                ctx.router.navigateTo(
                    "https://www.linkedin.com/in/vojtechhoranek",
                )
            },
            colorPalette = TertiaryColorPalette
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(0.5.cssRem),
                modifier = Modifier
                    .color(sitePalette.onTertiary),
            ) {
                SiteIcon(SiteIconKind.LinkedIn)
                Text("LinkedIn")
            }
        }
    }
}
